module.exports = __webpack_public_path__ + "static/s-exam4-6fb36f1981877ac3a973b4c4e23c02f4.png";